import React from 'react'

const AffiliateStatisticSkeleton = () => (
  <div className={'bg-background-secondary flex rounded-b-lg px-6 py-4'}>
    <div className={'flex w-1/3 justify-center'}>
      <div
        className={'bg-skeleton-primary w-[100px] animate-pulse rounded-md py-2 text-transparent '}
      >
        .
      </div>
    </div>
    <div className={'flex w-1/3 justify-center'}>
      <div
        className={'bg-skeleton-primary w-[100px] animate-pulse rounded-md py-2 text-transparent '}
      >
        .
      </div>
    </div>
    <div className={'flex w-1/3 justify-center'}>
      <div
        className={'bg-skeleton-primary w-[100px] animate-pulse rounded-md py-2 text-transparent '}
      >
        .
      </div>
    </div>
  </div>
)

export default AffiliateStatisticSkeleton
